/* eslint-disable no-param-reassign */

import { createSlice } from "@reduxjs/toolkit";
import { isElectronApp } from "../common/utils/electronAppHelper";
import moduleSetting from "../config/config.module";
import { LIMIT_SETTING } from "../config/config.limit";

const initialState = {
  message: {
    open: false,
    content: "",
  },
  // todo: 若是 electron app, 讀取 moduleSetting, 若是 web app, 讀取 firebase 設定
  moduleSetting: isElectronApp() ? moduleSetting : null, // 模組設定
  limitSetting: isElectronApp() ? LIMIT_SETTING : LIMIT_SETTING, // 模組 limit
  loader: {
    open: false,
    // value: 20, // loader 顯示的百分比
  },
  dialogContext: {
    openSignal: false,
    title: "",
    contentText: "",
    yesText: "yes",
    noText: "no",
    onYes: () => null,
    onNo: () => null,
    onClose: () => null,
  },
};

const MESSAGE_TYPE = {
  success: "success",
  error: "error",
  info: "info",
  warning: "warning",
};

const commonSlice = createSlice({
  name: "common",
  initialState,
  reducers: {
    setMessage: (state, action) => {
      state.message = { ...action.payload };
    },
    setSuccessMessage: (state, action) => {
      state.message = { ...action.payload, type: MESSAGE_TYPE.success };
    },
    setInfoMessage: (state, action) => {
      state.message = { ...action.payload, type: MESSAGE_TYPE.info };
    },
    setWarningMessage: (state, action) => {
      state.message = { ...action.payload, type: MESSAGE_TYPE.warning };
    },
    setErrorMessage: (state, action) => {
      state.message = { ...action.payload, type: MESSAGE_TYPE.error };
    },
    clearMessage: (state, action) => {
      state.message = { ...initialState.message };
    },
    setModuleSetting: (state, action) => {
      state.moduleSetting = action.payload;
    },
    setLoader: (state, action) => {
      state.loader = action.payload;
    },
    setCommonDialogContext: (state, action) => {
      state.dialogContext = { ...action.payload };
    },
  },
});

export const {
  setMessage,
  setSuccessMessage,
  setInfoMessage,
  setWarningMessage,
  setErrorMessage,
  setModuleSetting,
  setLoader,
  clearMessage,
  setCommonDialogContext,
} = commonSlice.actions;

export default commonSlice.reducer;
